import { Component, Input } from '@angular/core';

interface Additional {
  name: string;
  percentage: number;
  type: string;
  companyName?: string;
}

interface Seller {
  name: string;
  isFilled: boolean;
  type: string;
  percentage: number;
  additional: Additional[];
}
@Component({
  selector: 'app-other-sellers-percent',
  templateUrl: './other-sellers-percent.component.html',
  styleUrls: ['./other-sellers-percent.component.scss']
})
export class OtherSellersPercentComponent {

  @Input() otherSellers: any;
  displaySellers: (Seller | Additional)[] = [];

  ngOnInit(){
    this.flattenSellers();
  }


  flattenSellers() {
    this.displaySellers = [];


    this.otherSellers.forEach((seller: Seller) => {

      if (seller.type === 'PJ') {

        const sellerData = {
          name: seller.name,
          isFilled: seller.isFilled,
          type: 'PJ',
          percentage: 0,
          additional: [] as Additional[]
        };


        seller.additional?.forEach((additional: Additional) => {
          let formattedName = `${additional.name} (${additional.type === 'REPRESENTATIVE' ? 'representante' : 'procurador'}) receberá ${additional.percentage}%`;
          sellerData.additional.push({ name: formattedName, percentage: additional.percentage, type: additional.type });
        });


        this.displaySellers.push(sellerData);
      } else {

        const sellerData = {
          name: seller.name,
          isFilled: seller.isFilled,
          type: 'PF',
          percentage: seller.percentage
        };

        this.displaySellers.push(sellerData);


        seller.additional?.forEach((additional: Additional) => {
          const formattedName = `${additional.name} (cônjuge de ${seller.name})`;
          this.displaySellers.push({
            name: formattedName,
            percentage: additional.percentage,
            isFilled: seller.isFilled,
            type: 'CÔNJUGE'
          });
        });
      }

    });
  }
}
